import { makeAutoObservable } from "mobx";
import Cookies from "js-cookie";

class ThemeStore {
  theme = "light";

  constructor() {
    makeAutoObservable(this);
  }

  initializeTheme = () => {
    // 1. Check cookie first
    const savedTheme = Cookies.get("theme");

    if (savedTheme && (savedTheme === "light" || savedTheme === "dark")) {
      this.theme = savedTheme;
    } else {
      // 2. Fallback to system preference
      const prefersDark = window.matchMedia(
        "(prefers-color-scheme: dark)",
      ).matches;
      this.theme = prefersDark ? "dark" : "light";
      Cookies.set("theme", this.theme, { sameSite: "Strict", expires: 365 });
    }

    this.applyThemeToBody();

    // 3. Listen for system theme changes
    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", this.handleSystemThemeChange);
  };

  applyThemeToBody = () => {
    document.body.classList.remove("light", "dark");
    document.body.classList.add(this.theme);
  };

  toggleTheme = () => {
    const newTheme = this.theme === "light" ? "dark" : "light";
    this.setTheme(newTheme);
  };

  setTheme = (newTheme) => {
    this.theme = newTheme;
    Cookies.set("theme", newTheme, { sameSite: "Strict", expires: 365 });
    this.applyThemeToBody();
  };

  handleSystemThemeChange = (e) => {
    const newTheme = e.matches ? "dark" : "light";
    this.setTheme(newTheme);
  };

  // Computed values
  get isDark() {
    return this.theme === "dark";
  }

  get isLight() {
    return this.theme === "light";
  }
}

export const themeStore = new ThemeStore();
